'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as FlipMoveConfig from '../../../config/style/FlipMoveListConfig';
import {LoadMoreComponent} from '../../../core-components/loading-icon/components/LoadMoreComponent';
import {StatusOverlayComponent} from '../../../core-components/loading-icon/components/StatusOverlayComponent';
import {ViewMode, ViewModePropType} from '../../../core-utilities/enums/ViewMode';
import {MeasuredChatView} from '../MeasuredChatView';


export class ListComponent extends Component {
  static propTypes = {
    className: T.string,
    transitionGroupClass: T.string,
    transitionName: T.string,
    useScroll: T.bool,
    useAnimation: T.bool,

    mode: ViewModePropType,

    onLoadMore: T.func,

    ...StatusOverlayComponent.propTypes,
  };

  static defaultProps = {
    // Animation library performance is totally broken...
    useAnimation: false,
    flipped: false,
    autoScroll: false,
    scrollLoadThreshold: 50,
    transitionName: FlipMoveConfig.transitionName,
  };

  render() {
    return (
      <div
        className={classNames("List", this.props.className, {
          List_useScroll: this.props.useScroll,
        })}
        onClick={this.props.onClick}
      >
        <StatusOverlayComponent
          mode={this.props.mode}
          showNoData={this.props.showNoData}
          showNoDataIcon={this.props.showNoDataIcon}
          noDataTitle={this.props.noDataTitle}
          noDataLabel={this.props.noDataLabel}
          noDataIcon={this.props.noDataIcon}
          useNoDataImage={this.props.useNoDataImage}
        />
        {this.props.mode === ViewMode.LOADING ? null : this.renderList()}
      </div>
    );
  }

  renderList() {
    const props = this.props;

    return props.useScroll ? (
      <div className="List__scrollArea">
        <MeasuredChatView
          className="List__scroll"
          useSmoothScrollingWrapper={false}
          flipped={props.flipped}
          autoScroll={props.autoScroll}
          usePropLoading={true}
          scrollLoadThreshold={props.scrollLoadThreshold}
          isInfiniteLoading={props.mode === ViewMode.LOADING_MORE}
          loadingSpinnerDelegate={<LoadMoreComponent mode={props.mode} />}
          onInfiniteLoad={props.onLoadMore}
        >
          {this.renderListContents()}
        </MeasuredChatView>
      </div>
    ) : (
      this.renderListContents()
    );
  }

  renderListContents() {
    return this.props.useAnimation ? (
      <ReactCSSTransitionGroup
        className={this.props.transitionGroupClass}
        transitionName={this.props.transitionName}
        transitionAppear={FlipMoveConfig.transitionAppear}
        transitionAppearTimeout={FlipMoveConfig.transitionAppearTimeout}
        transitionEnterTimeout={FlipMoveConfig.transitionEnterTimeout}
        transitionLeaveTimeout={FlipMoveConfig.transitionLeaveTimeout}
      >
        {this.props.children}
      </ReactCSSTransitionGroup>
    ) : (
      <div className={this.props.transitionGroupClass}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/lists/List/ListComponent.js